import axios from "axios";
import {Storage} from "@/Services/Storage";

export default {
    name: 'orders',
    state: {
        currentTab: 1,
        itemsToScan: [],
        scannedItems: [],
        canAssignUser : false
    },
    getters: {
        getCurrentTab: (state) => state.currentTab,
        getItemsToScan: (state) => state.itemsToScan,
        getScannedItems: (state) => state.scannedItems,
        getAssignUserValue: (state) => state.canAssignUser,
    },
    mutations: {
        setAssignUserValue:(state , payload) => state.canAssignUser = payload,
        setItemsToScan: (state, payload) => state.itemsToScan = payload,
        setCurrentTab: (state, payload) => state.currentTab = payload,
        setScannedItems: (state, payload) => state.scannedItems = payload,
        addToScannedItems: (state, payload) => {
            let id = payload.plu;
            let notScanned = state.itemsToScan.find(notScanned => notScanned.plu.toLowerCase() === id.toLowerCase());
            if (!notScanned) {
                return responses.showWarning(`Item not Found !!`);
            }
            if (notScanned.Qty > 1) {
                notScanned.Qty--;
            } else {
                state.itemsToScan = state.itemsToScan.filter(item => item.plu.toLowerCase() !== id.toLowerCase());
            }
            let item = state.scannedItems.find(item => item.plu.toLowerCase() === id.toLowerCase());
            if (item) {
                item.Qty++;
            } else {
                state.scannedItems.push({
                    id: payload.id,
                    plu: payload.plu,
                    barcode: payload.barcode,
                    description: payload.description,
                    unit_of_measure: payload.unit_of_measure,
                    Qty: 1,
                    PickingID: payload.PickingID
                })
            }
        },
    },
    actions: {
        getItemsByOrderNumber: async (context, orderNumber) => {
            return axios.get(navTomcatApi+`picking/open?DontMark=true&id=${orderNumber}`)
                .then(({data})=>context.commit(`setItemsToScan`,data))
                .catch(err => errorHandler.tomcatError(err));
        },
        finalizeOrder: async (context, orderNumber) => {
            let user = await Storage.getCurrentUser();
            user = user.Username;
            let obj = context.getters.getScannedItems;
            return axios.post(navTomcatApi + `completed?id=${orderNumber}&user=${user}`, obj)
                .catch(err => errorHandler.tomcatError(err))
        },
        getRefreshOrders: async () => {
            return axios.get(navTomcatApi + `refresh/all`)
                .then(({data})=>data)
                .catch(err => errorHandler.tomcatError(err))
        },
        getNewOrders: async () => {
            let location = await Storage.getCurrentLocationID();
            return  axios.get(navTomcatApi + `new/getAll?offset=0&limit=850&location=` + location)
                .then(({data}) => data)
                .catch(err => errorHandler.tomcatError(err))
        },

        getOrdersInDispatch: async () => {
            let location = await Storage.getCurrentLocationID();
            return  axios.get(navTomcatApi + `dispatch/getAll?offset=0&limit=850&location=` + location)
                .then(({data}) => data)
                .catch(err => errorHandler.tomcatError(err))
        },

        getApprovedOrders: async () => {
            let location = await Storage.getCurrentLocationID();
            return  axios.get(navTomcatApi + `readyToPick/getAll?offset=0&limit=850&location=` + location)
                .then(({data}) => data)
                .catch(err => errorHandler.tomcatError(err))
        },

        getOrdersInPicking: async () => {
            let location = await Storage.getCurrentLocationID();
            return axios.get(navTomcatApi+`picking/getAll?offset=0&limit=850&location=`+location)
                .then(({data}) => data)
                .catch(err => errorHandler.tomcatError(err))
        },

        getCheckedOutOrders: async () => {
            let location = await Storage.getCurrentLocationID();
            return axios.get(navTomcatApi+`checkout/getAll?offset=0&limit=850&location=`+location)
                .then(({data}) => data)
                .catch(err => errorHandler.tomcatError(err))
        },

        getOrdersByCurrentTab: async (context) => {
            let location = await Storage.getCurrentLocationID();
            if (!location) return;
            let currentTab = context.getters.getCurrentTab;
            switch (currentTab) {
                case 1 :
                    return context.dispatch(`getNewOrders`).then(res => res);
                case 2 :
                    return context.dispatch(`getOrdersInPicking`).then(res => res);
                case 3 :
                    return context.dispatch(`getCheckedOutOrders`).then(res => res);
                case 4 :
                    return context.dispatch(`getOrdersInDispatch`).then(res => res);
                case 5 :
                    return context.dispatch(`getApprovedOrders`).then(res => res);
                default:
                    return context.dispatch(`getNewOrders`).then(res => res);
            }
        },
        getDSROrders: async (context , isProcessed = false) => {
            let dateRange = context.getters.getGlobalDateRange;
            let payload = {
                from : dateRange.From+` 00:00:00`,
                to : dateRange.To+` 23:59:59`,
                Processed : isProcessed
            }
            return axios.get(franchiseTomcatApi + `navision/l_and_a_logistics_l_and_a_logistics/getOrderList`,{ params : payload })
                .then(({data}) =>data)
                .catch(err => errorHandler.tomcatError(err))
        },

        getCashUps: async (context , isProcessed = false) => {
            let dateRange = context.getters.getGlobalDateRange;
            let payload = {
                from : dateRange.From+` 00:00:00`,
                to : dateRange.To+` 23:59:59`,
                Processed : isProcessed
            }
            return axios.get(franchiseTomcatApi + `navision/l_and_a_logistics_l_and_a_logistics/cashupList/1004117420`,{ params : payload })
                .then(({data}) =>data)
                .catch(err => errorHandler.tomcatError(err))
        },

        getIncomingOrders:(context) => {
            let dateRange = context.getters.getGlobalDateRange;
            let payload = {
                from : dateRange.From+` 00:00:00`,
                to : dateRange.To+` 23:59:59`,
            }
            return axios.get(wareHouseTomcatApi+`indoxa/getAllNotDownlaoded`,{ params : payload })
                .then(({data}) =>data)
                .catch(err => errorHandler.tomcatError(err))
        },

        getDownloadedOrders:(context) => {
            let dateRange = context.getters.getGlobalDateRange;
            let payload = {
                from : dateRange.From+` 00:00:00`,
                to : dateRange.To+` 23:59:59`,
            }
            return axios.get(wareHouseTomcatApi+`indoxa/getCompleted`,{ params : payload })
                .then(({data}) =>data)
                .catch(err => errorHandler.tomcatError(err))
        },
        // Function to open the first URL
        downloadOrder: async function (context, id) {
            console.log("starting...");

            try {
                let user = await Storage.getCurrentUser();
                user = user.Username;

                // Define the URLs
                const url1 = `${wareHouseTomcatApi}indoxa/download?ordernum=${id}&user=${user}`;
                const url2 = `${wareHouseTomcatApi}magic/getError/${id}`;

                // Download the first file
                console.log(`Downloading file from: ${url1}`);
                const response1 = await axios.get(url1, { responseType: "blob" });
                const file1Url = window.URL.createObjectURL(new Blob([response1.data]));
                const link1 = document.createElement("a");
                link1.href = file1Url;
                link1.setAttribute("download", "report #1.csv");
                document.body.appendChild(link1);
                link1.click();
                link1.remove();

                // Download the second file
                console.log(`Downloading file from: ${url2}`);
                const response2 = await axios.get(url2, { responseType: "blob" });
                const file2Url = window.URL.createObjectURL(new Blob([response2.data]));
                const link2 = document.createElement("a");
                link2.href = file2Url;
                link2.setAttribute("download", "report #2.csv");
                document.body.appendChild(link2);
                link2.click();
                link2.remove();

                console.log("Both files downloaded successfully.");
            } catch (error) {
                console.error("Error during file downloads:", error);
                errorHandler.tomcatError(error); // Graceful error handling
            }
        },
        secondroute: async function (id) {
            let user = await Storage.getCurrentUser();
        },
        archiveOrders:async (context , orders)=> {
            return axios.post(wareHouseTomcatApi+`indoxa/archive`,orders)
                .catch(err=>errorHandler.tomcatError(err))
        },

        approveOrder:async (context , orderNumber)=> {
            let user = await Storage.getCurrentUser();
            let obj  = {
                orderNumber,
                user : user.Username
            };
            return axios.post(wareHouseTomcatApi+`nav/new/approve`,obj)
                .catch(err=>errorHandler.tomcatError(err))
        },
        unApproveOrder:async (context , orderNumber)=> {
            let user = await Storage.getCurrentUser();
            let obj  = {
                orderNumber,
                user : user.Username
            };
            return axios.post(wareHouseTomcatApi+`nav/new/unApprove`,obj)
                .catch(err=>errorHandler.tomcatError(err))
        },

        rePickOrder:async (context , orderNumber)=> {
            let user = await Storage.getCurrentUser();
            let obj  = {
                orderNumber,
                user : user.Username
            };
            return axios.post(wareHouseTomcatApi+`nav/dispatch/repick`,obj)
                .catch(err=>errorHandler.tomcatError(err))
        },

        getCustomerOrders:(context , payload) => {
            let dateRange = context.getters.getGlobalDateRange;
            payload = {
                ...payload,
                from : dateRange.From+` 00:00:00`,
                to : dateRange.To+` 23:59:59`,
            }
            return axios.get(wareHouseTomcatApi+`indoxa/getAllNotDownlaoded`,{ params : payload })
                .then(({data}) =>data)
                .catch(err => errorHandler.tomcatError(err))
        },

        refreshOrder:async (context , orderNumber) => {
            let payload = [{orderNumber}]
            return axios.post(navTomcatApi + `refresh/refreshOrder`,payload)
                .catch(err => errorHandler.tomcatError(err))
        },

    }
}
